export const WAITING = 0
export const APPEALABLE = 1
export const SOLVED = 2
